import React, { Component } from "react";
import PropTypes from "prop-types";

import { Fieldset, Field, Control, Label, Input } from "rbx";
import { Mutation } from "react-apollo";
import { ErrorMessage } from "../ErrorMessage";
import { UPDATE_CUSTOMER_MUTATION } from "../../graphql/Customers/Customers.graphql";
import { getUTCFormattedDate } from "../../utils";
import {
  AddressInput,
  BooleanInput,
  CurrencyInput,
  DateInput,
  PhoneNumberInput,
  SystemCodeSelect
} from "../inputs";

class EditCustomerForm extends Component {
  state = {
    // CustomerNo: "",
    Name: "",
    Active: "",
    CustomerTypeRecIdRef: "",
    Telephone: "",
    FaxNo: "",
    BillingContactName: "",
    LastSaleDate: "",
    LastSaleAmount: "",
    Address1: "",
    Address2: "",
    City: "",
    State: "",
    Zip: "",
    ...this.props.customer
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const {
      // CustomerNo,
      Name,
      Active,
      CustomerTypeRecIdRef,
      Telephone,
      FaxNo,
      BillingContactName,
      LastSaleDate,
      LastSaleAmount,
      Address1,
      Address2,
      City,
      State,
      Zip
    } = this.state;
    const { disabled, onSubmitComplete, customerFormId } = this.props;
    return (
      <Mutation
        mutation={UPDATE_CUSTOMER_MUTATION}
        refetchQueries={["ALL_CUSTOMERS_QUERY"]}
        variables={{
          data: {
            // CustomerNo: parseInt(CustomerNo),
            Name,
            Active,
            CustomerTypeRecIdRef: parseInt(CustomerTypeRecIdRef),
            Telephone,
            FaxNo,
            BillingContactName,
            LastSaleDate: getUTCFormattedDate(LastSaleDate),
            LastSaleAmount,
            Address1,
            Address2,
            City,
            State,
            Zip
          },
          where: {
            RecId: this.props.customer.RecId
          }
        }}
      >
        {(updateCustomer, { loading, error }) => (
          <form
            id={customerFormId}
            method="POST"
            onSubmit={async e => {
              e.preventDefault();
              await updateCustomer();
              onSubmitComplete();
            }}
          >
            <ErrorMessage error={error} />
            <Fieldset disabled={disabled || loading}>
              <Field kind="group">
                {/* <Control>
                  <Label>Customer No</Label>
                  <Input autocomplete="new" 
                    type="text"
                    name="CustomerNo"
                    value={CustomerNo}
                    onChange={this.onChange}
                  />
                </Control> */}
                <Control expanded>
                  <Label>Name</Label>
                  <Input
                    required
                    autocomplete="new"
                    name="Name"
                    type="text"
                    value={Name}
                    onChange={this.onChange}
                  />
                </Control>

                <Control expanded>
                  <SystemCodeSelect
                    required
                    icon="globe"
                    label="Customer Type"
                    lookup={{ Category: "Customer", Code: "CustomerType" }}
                    name="CustomerTypeRecIdRef"
                    type="text"
                    value={CustomerTypeRecIdRef}
                    onChange={this.onChange}
                  />
                </Control>
                <Control>
                  <Label>Active</Label>
                  <BooleanInput
                    label="active"
                    name="Active"
                    value={Active}
                    onChange={this.onChange}
                  />
                </Control>
              </Field>
              <AddressInput
                Address1={Address1}
                Address2={Address2}
                City={City}
                State={State}
                Zip={Zip}
                onChange={this.onChange}
              />

              <Field kind="group">
                <Control>
                  <Label>Telephone</Label>
                  <PhoneNumberInput
                    name="Telephone"
                    value={Telephone}
                    onChange={this.onChange}
                  />
                </Control>
                <Control>
                  <Label>Fax No</Label>
                  <PhoneNumberInput
                    name="FaxNo"
                    value={FaxNo}
                    onChange={this.onChange}
                  />
                </Control>
                <Control expanded>
                  <Label>Billing Contact Name</Label>
                  <Input
                    autocomplete="new"
                    name="BillingContactName"
                    type="text"
                    value={BillingContactName}
                    onChange={this.onChange}
                  />
                </Control>
                <Control>
                  <Label>Last Sale Date</Label>
                  <DateInput
                    name="LastSaleDate"
                    value={LastSaleDate}
                    onChange={this.onChange}
                  />
                </Control>
                <Control>
                  <Label>Last Sale Amount</Label>
                  <CurrencyInput
                    name="LastSaleAmount"
                    value={LastSaleAmount}
                    onChange={this.onChange}
                  />
                </Control>
              </Field>
            </Fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

EditCustomerForm.propTypes = {
  disabled: PropTypes.bool,
  customer: PropTypes.object,
  onSubmitComplete: PropTypes.func,
  customerFormId: PropTypes.string
};
EditCustomerForm.defaultProps = {
  customer: {}
};
export default EditCustomerForm;
